import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetExpensesByProjectQuery } from "../../../services/Reports";
import {
  getExpensesByProjectRequest,
  getExpensesByProjectFailure,
  getExpensesByProjectSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allExpensesByProject,
    isLoading: expensesByProjectLoading,
    isError: expensesByProjectError,
  } = useGetExpensesByProjectQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.expensesByProjectPageNo,
    pageSize: state.expensesByProjectPageSize,
    fromDate: new Date(state.expensesByProjectFromDate).toLocaleDateString(),
    toDate: new Date(state.expensesByProjectToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (expensesByProjectLoading) {
      dispatch(getExpensesByProjectRequest());
    }
    if (expensesByProjectError) {
      dispatch(getExpensesByProjectFailure(expensesByProjectError));
    }
    if (allExpensesByProject) {
      dispatch(
        getExpensesByProjectSuccess({
          data: allExpensesByProject.data.expensesByProject[0].data || [],
          totalPages:
            allExpensesByProject.data.expensesByProject[0].metadata[0]?.total ||
            0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allExpensesByProject,
    profileData,
    state.expensesByProjectFromDate,
    state.expensesByProjectToDate,
    state.expensesByProjectPageNo,
    state.expensesByProjectPageSize,
  ]);
  return <></>;
};
export default Content;
